import conversations from './sidebarItems/conversations';
import contactViews from './sidebarItems/contactViews';
import contacts from './sidebarItems/contacts';
import intelligenceDashboard from './sidebarItems/intelligenceDashboard';
import reports from './sidebarItems/reports';
//import campaigns from './sidebarItems/campaigns';
import campaigns from './sidebarItems/campaignsManager';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenuCustom';
import aiAgents from './sidebarItems/aiAgents';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contactViews(accountId),
    contacts(accountId),
    intelligenceDashboard(accountId),
    reports(accountId),
    campaigns(accountId),
    settings(accountId),
    notifications(accountId),
    aiAgents(accountId),
  ],
});
